import React from "react";
import DatePicker from "react-datepicker";
import { StyledLabel, StyledRequired, Error, Hint } from "./styles";

// import required css from library
import "react-datepicker/dist/react-datepicker.css";
import styled from "styled-components";

const SDatePicker = styled.div`
    .react-datepicker-wrapper {
        input {
            border: 0;
            font-size: 16px;
            color: hsl(0, 0%, 20%);
            font-weight: 400;
            width: 100%;
            outline: none;
            border: 1px solid #9a9c9f;
            border-radius: 6px;
            padding: 9px;
            :disabled {
                border: none;
                background-color: transparent;
                padding: 0;
            }
        }
    }
    .react-datepicker__time-container {
        padding: 0;
    }
    .react-datepicker__current-month,
    .react-datepicker-time__header {
        display: block;
        padding: 10px;
    }
    .react-datepicker__navigation--next,
    .react-datepicker__navigation--previous {
        visibility: visible !important;
        .react-datepicker__navigation-icon--next,
        .react-datepicker__navigation-icon--previous {
            display: none;
        }
    }
    .react-datepicker__time-container
        .react-datepicker__time
        .react-datepicker__time-box
        ul.react-datepicker__time-list::-webkit-scrollbar {
        width: 4px;
        height: 4px;
    }

    .react-datepicker--time-only
        .react-datepicker__time-container
        .react-datepicker__time
        .react-datepicker__time-box {
        width: 160px;
    }
    .react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle::before,
    .react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle::before,
    .react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle::after,
    .react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle::after {
        left: -26px;
    }
`;
function DatePickerTimeOnlyInput({
    selectedValue,
    name,
    onChange,
    required,
    label,
    dateFormat,
    error,
    isEditable,
}) {
    return (
        <>
            <StyledLabel>
                {label} {required && <StyledRequired>*</StyledRequired>}
            </StyledLabel>
            <SDatePicker>
                <DatePicker
                    disabled={!isEditable}
                    selected={selectedValue}
                    onChange={onChange}
                    dateFormat={dateFormat}
                    name={name}
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={15}
                    timeCaption="Time"
                />
                <Hint>{error && required && <Error>please fill this field </Error>}</Hint>
            </SDatePicker>
        </>
    );
}

export default DatePickerTimeOnlyInput;
